import "./ContactPageItem.scss";

const ContactPageItem = ({ children }) => {
  return <div className="contactPage__content--item">{children}</div>;
};

export default ContactPageItem;
